export default __webpack_public_path__ + "static/media/race_placeholder_3.c25fadda.png";